<template>
	<div class="ttshop_user">
		<Header></Header>
		<Userheader></Userheader>
		<div class="ttshop_user">
			<div class="ttshop_usercon w clearfloat">
				<div class="ttshop_orderxq">
					<!-- 面包屑 -->
					<div class="ttshop_ordernav clearfloat">
						<p class="ttshop_navtext">个人中心</p>
						<span>&gt;</span>
						<p class="ttshop_navtext">订单中心</p>
						<span>&gt;</span>
						<p class="ttshop_orderdh">订单：<strong>15245665538</strong></p>
					</div>
					<!-- 我要换货/退货(商家发货) -->
					<div class="ttshop_orderdzf clearfloat">
						<div class="ttshop_orderdzfleft d-flex align-items-center justify-content-center">
							<h4>商家已发货</h4>
						</div>
						<div class="ttshop_orderdzfright">
							<ul class="clearfloat">
								<li class="active">
									<h5>1</h5>
									<p>申请换货</p>
									<span>2020-07-11 21:28:21</span>
								</li>
								<li class="active">
									<h5>2</h5>
									<p>商家同意</p>
									<span>2020-07-11 21:28:21</span>
								</li>
								<li class="active">
									<h5>3</h5>
									<p>卖家发货</p>
									<span>2020-07-11 21:28:21</span>
								</li>
								<li class="active">
									<h5>4</h5>
									<p>商家发货</p>
									<span>2020-07-11 21:28:21</span>
								</li>
								<li>
									<h5>5</h5>
									<p>评价</p>
									<span></span>
								</li>
							</ul>
						</div>
					</div>
					
					<!-- 地址及物流信息 -->
					<div class="ttshop_orderdzwl clearfloat">
						<div class="ttshop_orderdzwleft">
							<h5>收货人信息</h5>
							<ul>
								<li class="clearfloat">
									<p>收货人：</p>
									<span>创唯唯</span>
								</li>
								<li class="clearfloat">
									<p>收货地址：</p>
									<span>北京海淀区三环到四环之间海淀区苏州街长远天地大厦A1座12a03</span>
								</li>
								<li class="clearfloat">
									<p>电话：</p>
									<span>15232552585</span>
								</li>
							</ul>
						</div>
						<div class="ttshop_orderdzwlright">
							<!-- 暂无物流订单信息显示 -->
							<div class="ttshop_orderdzwlzw">
								<h5>暂时没有订单信息</h5>
								<p>您的订单已签收。感谢您在京东购物，欢迎再次光临。参加评价还能赢取京豆哟。</p>
							</div>
							
							<div class="ttshop_orderdzwlxinxi">
								<ul>
									<li class="clearfloat">
										<div class="ttshop_xinxitime">
											2018-12-13/周四 10:47:09
										</div>
										<i></i>
										<div class="ttshop_jieduan">
											<h5>已签收</h5>
											<p>您的订单已签收。感谢您在京东购物，欢迎再次光临。参加评价还能赢取京豆哟。</p>
										</div>
									</li>
									<li class="clearfloat">
										<div class="ttshop_xinxitime">
											10:47:09
										</div>
										<i></i>
										<div class="ttshop_jieduan">
											<h5>已签收</h5>
											<p>【华北众包站】我是您的专属配送员孙召军，您的订单已到达华北众包站，配送小哥会尽快为您配送，请您留意，如需要更改配送时间或者未如期到达，均可给我打电话18310096998，很高兴为您服务！</p>
										</div>
									</li>
									<li class="clearfloat">
										<div class="ttshop_xinxitime">
											2018-12-12/周三 16:17:42
										</div>
										<i></i>
										<div class="ttshop_jieduan">
											<h5>运输中</h5>
											<p>您的订单已到达【北京中关村营业部】</p>
										</div>
									</li>
									<li class="clearfloat">
										<div class="ttshop_xinxitime">
											2020-12-12/周三 16:17:42
										</div>
										<i></i>
										<div class="ttshop_jieduan">
											<h5>已出库</h5>
											<p>您的订单已出库</p>
										</div>
									</li>
								</ul>
							</div>
						</div>
					</div>
					
					<!-- 商品信息 -->
					<div class="ttshop_barteragreeshop">
						<div class="ttshop_barternav clearfloat">
							<p class="ttshop_bartershop">商品信息</p>
							<p class="ttshop_barterdj">单价</p>
							<p class="ttshop_barterdj">数量</p>
							<p class="ttshop_barterdj">支付总金额</p>
						</div>
						<div class="ttshop_bartercon">
							<div class="ttshop_barterlist">
								<div class="ttshop_barterlistitle clearfloat">
									<p>2019-08-20 11:55:41</p>
									<p>订单号：<span>127830913797</span></p>
									<p>卖家：<strong>太平鸟官方旗舰店</strong></p>
								</div>
								<div class="ttshop_barterlistcon clearfloat">
									<div class="ttshop_bartershoping clearfloat">
										<div class="ttshop_barterimg">
											<img src="../../assets/images/goods_1.png" alt="">
										</div>
										<div class="ttshop_bartertext">
											<h5>GXG男装 2019夏季新款商场同款男士纯棉潮流白色圆领短袖T恤男</h5>
											<span>颜色：<strong>白色</strong></span>
											<span>尺寸：<strong>170/M</strong></span>
										</div>
									</div>
									<div class="ttshop_barterdjer">
										<p>¥ 464.00</p>
									</div>
									<div class="ttshop_barterdjer">
										<p>2</p>
									</div>
									<div class="ttshop_barterdjer">
										<p>¥ 4640.00</p>
									</div>
								</div>
							</div>
						</div>
					</div>
					
					<!-- 收货人信息 -->
					<div class="ttshop_barteragreebut">
						<h4>收货人信息</h4>
						<div class="ttshop_barteragreelist clearfloat">
							<div class="ttshop_barteragreeleft">
								<h5>北京市海淀区长远天地大厦1233</h5>
								<ul>
									<li class="clearfloat">
										<span>快递公司：</span>
										<div class="ttshop_bartersele">
											<p>京东快递</p>
										</div>
									</li>
									<li class="clearfloat">
										<span>快递单号：</span>
										<div class="ttshop_bartersele">
											<p>2472389732849</p>
										</div>
									</li>
								</ul>
							</div>
							<div class="ttshop_barteragreeright">
								<p class="clearfloat"><strong>售后类型：</strong><span>换货 </span></p>
								<p class="clearfloat"><strong>申请原因：</strong><span>快来讲述的空间啊上课就撒辣椒粉流口水的份</span></p>
								<ul class="clearfloat">
									<li><img src="../../assets/images/goods_1.png" alt=""></li>
									<li><img src="../../assets/images/goods_1.png" alt=""></li>
									<li><img src="../../assets/images/goods_1.png" alt=""></li>
									<li><img src="../../assets/images/goods_1.png" alt=""></li>
									<li><img src="../../assets/images/goods_1.png" alt=""></li>
								</ul>
							</div>
						</div>
					</div>
					
				</div>
			</div>	
		</div>
		<Foot></Foot>
	</div>
</template>

<script>
	import Header from "@/components/header/header";
	import Foot from "@/components/foot/foot";
	import Userheader from "./components/user_index";
	export default {
		components: {
			Header,
			Userheader,
			Foot,
		},
		data() {
			return {
				
			}
		},
		mounted(){
			
		}
	};
</script>

<style  lang="scss" scoped>
	.ttshop_orderxq{
		width: 100%;
		.ttshop_ordernav{
			width: 100%;
			margin-bottom: 20px;
			.ttshop_navtext{
				float: left;
				cursor: pointer;
				font-size: 12px;
				color: #333;
				transition: .5s;
				-moz-transition: .5s;
				-webkit-transition: .5s;
				-o-transition: .5s;
				&:hover{
					color:#ff0e25;
				}
			}
			span{
				float: left;
				font-size: 12px;
				color: #333;
				margin: 0 5px;
			}
			.ttshop_orderdh{
				float: left;
				font-size: 12px;
				color: #333;
				strong{
					font-size: 12px;
					color: #333;
					font-weight: 400;
				}
			}
		}
		.ttshop_orderdzf{
			width: 100%;
			height: 200px;
			background: #fff;
			margin-bottom: 20px;
			.ttshop_orderdzfleft{
				float: left;
				width: 290px;
				height: 200px;
				background: #FF9010;
				padding: 32px;
				box-sizing: border-box;
				h4{
					font-size: 20px;
					color: #fff;
					font-weight: 500;
					text-align: center;
				}
			}
			.ttshop_orderdzfright{
				float: left;
				width: 900px;
				height: 200px;
				background: #fff;
				padding: 66px 30px;
				box-sizing: border-box;
				ul{
					li{
						width: 20%;
						float: left;
						position: relative;
						h5{
							display: block;
							width: 24px;
							height: 24px;
							border-radius: 50%;
							background: #EBEBEB;
							text-align: center;
							line-height: 24px;
							font-size: 14px;
							color: #999;
							font-weight: 500;
							margin: 0 auto 13px;
							position: relative;
							z-index: 10;
						}
						p{
							font-size: 12px;
							color: #999;
							text-align: center;
							margin-bottom: 8px;
						}
						span{
							display: block;
							text-align: center;
							font-size: 12px;
							color: #999;
							height: 16px;
						}
						&.active::before{
							background: #FF9010;
						}
						&.active h5{
							background: #FF9010;
							color: #fff;
						}
						&.active p{
							color: #FF9010;
						}
						&:first-child::before{
							width: 50%;
							left: 57%;
							top: 14%;
							transform: translateX(0%);
						}
						&::before{
							content: "";
							position: absolute;
							top: 14%;
							left: 50%;
							transform: translateX(-50%);
							width: 100%;
							height: 2px;
							background: #EBEBEB;
						}
					}
				}
			}
		}
		.ttshop_orderdzwl{
			width: 100%;
			height: 274px;
			background: #fff;
			margin-bottom: 20px;
			.ttshop_orderdzwleft{
				float: left;
				width: 346px;
				height: 274px;
				padding: 24px 40px 24px 20px;
				box-sizing: border-box;
				position: relative;
				&::before{
					content: "";
					width: 1px;
					height: 226px;
					background: #EBEBEB;
					position: absolute;
					top: 24px;
					right: -1px;
				}
				h5{
					font-size: 16px;
					color: #999;
					font-weight: 500;
					line-height: 16px;
					margin-bottom: 30px;
				}
				ul{
					li{
						width: 100%;
						margin-bottom: 20px;
						&:last-child{margin-bottom: 0;}
						p{
							float: left;
							font-size: 12px;
							color: #666;
							width: 60px;
							text-align: right;
							margin-right: 16px;
							line-height: 18px;
						}
						span{
							float: left;
							max-width: 210px;
							font-size: 12px;
							color: #333;
							line-height: 18px;
						}
					}
				}
			}
			.ttshop_orderdzwlright{
				float: left;
				width: 843px;
				height: 274px;
				padding: 24px 35px;
				box-sizing: border-box;
				.ttshop_orderdzwlzw{
					width: 100%;
					padding-top: 90px;
					box-sizing: border-box;
					display: none;
					h5{
						font-size: 16px;
						color: #333;
						text-align: center;
						line-height: 16px;
						font-weight: 500;
						margin-bottom: 12px;
					}
					p{
						font-size: 12px;
						color: #999;
						text-align: center;
						line-height: 18px;
						font-weight: 400;
					}
				}
				.ttshop_orderdzwlxinxi{
					width: 100%;
					height: 225px;
					overflow-y: scroll;
					ul{
						li{
							width: 100%;
							.ttshop_xinxitime{
								float: left;
								width: 150px;
								font-size: 12px;
								color: #333;
								font-weight: 400;
								line-height: 12px;
								margin-right: 16px;
								padding-top: 4px;
								box-sizing: border-box;
								text-align: right;
							}
							i{
								float: left;
								display: block;
								width: 20px;
								height: 20px;
								background: #CCCCCC;
								border-radius: 50%;
								margin-right: 16px;
								position: relative;
								z-index: 10;
							}
							.ttshop_jieduan{
								float: left;
								max-width: 510px;
								padding-top: 4px;
								padding-bottom: 24px;
								box-sizing: border-box;
								position: relative;
								h5{
									font-size: 12px;
									color: #333;
									font-weight: 500;
									line-height: 12px;
									margin-bottom: 8px;
								}
								p{
									font-size: 12px;
									color: #999;
									line-height: 18px;
									font-weight: 400;
								}
								&::before{
									content: "";
									width: 1px;
									height: 100%;
									background: #CCCCCC;
									position: absolute;
									top: 0;
									left: -26px;
								}
							}
							&:last-child .ttshop_jieduan:before{
								display: none;
							}
						}
					}
				}
			}
		}
		.ttshop_barteragreeshop{
			width: 100%;
			padding: 20px;
			box-sizing: border-box;
			background: #fff;
			margin-bottom: 20px;
			.ttshop_barternav{
				width: 100%;
				height: 32px;
				background: #F5F5F5;
				margin-bottom: 20px;
				.ttshop_bartershop{
					float: left;
					width: 40%;
					font-size: 12px;
					color: #333;
					padding-top: 8px;
					padding-left: 20px;
					box-sizing: border-box;
				}
				.ttshop_barterdj{
					float: left;
					width: 20%;
					font-size: 12px;
					color: #333;
					padding-top: 8px;
					box-sizing: border-box;
					text-align: center;
				}
			}
			.ttshop_bartercon{
				width: 100%;
				.ttshop_barterlist{
					width: 100%;
					.ttshop_barterlistitle{
						width: 100%;
						height: 32px;
						background: #F5F5F5;
						padding: 0 20px;
						box-sizing: border-box;
						p{
							float: left;
							font-size: 12px;
							color: #999;
							padding-top: 8px;
							box-sizing: border-box;
							margin-right: 24px;
							&:last-child{
								margin-right: 0;
							}
							span{
								font-size: 12px;
								color: #999;
							}
							strong{
								font-size: 12px;
								color: #333;
								font-weight: 500;
							}
						}
					}
					.ttshop_barterlistcon{
						width: 100%;
						height: 113px;
						border: 1px solid #EBEBEB;
						border-top: 0;
						box-sizing: border-box;
						.ttshop_bartershoping{
							float: left;
							width: 40%;
							height: 113px;
							padding: 16px 20px;
							box-sizing: border-box;
							border-right: 1px solid #EBEBEB;
							.ttshop_barterimg{
								float: left;
								width: 80px;
								height: 80px;
								margin-right: 12px;
								img{
									display: block;
									width: 100%;
									height: 100%;
									object-fit: cover;
								}
							}
							.ttshop_bartertext{
								float: left;
								width: 75%;
								h5{
									font-size: 12px;
									color: #333;
									line-height: 18px;
									font-weight: 400;
									margin-bottom: 8px;
								}
								span{
									font-size: 12px;
									color: #999;
									strong{
										font-size: 12px;
										color: #999;
										font-weight: 400;
									}
								}
							}
						}
						.ttshop_barterdjer{
							float: left;
							width: 20%;
							height: 113px;
							padding: 16px 20px;
							box-sizing: border-box;
							border-right: 1px solid #EBEBEB;
							&:last-child{border-right: 0;}
							p{
								font-size: 12px;
								color: #333;
								font-weight: 400;
								line-height: 18px;
								text-align: center;
							}
						}
					}
				}
			}
		}
		.ttshop_barteragreebut{
			width: 100%;
			padding: 24px 20px 60px 20px;
			box-sizing: border-box;
			background: #fff;
			h4{
				font-size: 16px;
				color: #999;
				font-weight: 500;
				line-height: 16px;
				margin-bottom: 28px;
			}
			.ttshop_barteragreelist{
				width: 100%;
				.ttshop_barteragreeleft{
					float: left;
					width: 48%;
					margin-right: 4%;
					h5{
						font-size: 12px;
						color: #333;
						font-weight: 400;
						line-height: 32px;
						overflow: hidden;
						white-space: nowrap;
						text-overflow: ellipsis;
						margin-bottom: 20px;
					}
					ul{
						li{
							margin-bottom: 16px;
							span{
								float: left;
								width:60px;
								font-size: 12px;
								color: #333;
								margin-right: 16px;
								line-height: 28px;
							}
							.ttshop_bartersele{
								float: left;
								width: 300px;
								height: 28px;
								line-height: 28px;
								box-sizing: border-box;
								p{
									font-size: 12px;
									color: #333;
								}
							}
							
						}
					}
				}
				.ttshop_barteragreeright{
					float: left;
					width: 48%;
					p{
						font-size: 12px;
						color: #333;
						padding-top: 7px;
						margin-bottom: 7px;
						box-sizing: border-box;
						strong{
							float: left;
							width: 60px;
							font-size: 12px;
							color: #333;
							font-weight: 500;
							margin-right: 16px;
						}
						span{
							float: left;
							width: 82%;
							font-size: 12px;
							color: #333;
						}
					}
					ul{
						margin-top: 20px;
						li{
							float: left;
							width: 60px;
							height: 60px;
							margin-right: 12px;
							&:last-child{margin-right: 0;}
							img{
								display: block;
								width: 100%;
								height: 100%;
								object-fit: cover;
							}
						}
					}
				}
			}
		}
	}
</style>
